// extracted by mini-css-extract-plugin
export default {"menuItem":"SelectGame_menuItem__fIpbQ","title":"SelectGame_title__JLK0K"};